import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import NotasFiscais1 from '../imagens/LancNotasFiscais/NotasFiscais1.png';
import NotasFiscais2 from '../imagens/LancNotasFiscais/NotasFiscais2.png';
import NotasFiscais3 from '../imagens/LancNotasFiscais/NotasFiscais3.png';
import NotasFiscais4 from '../imagens/LancNotasFiscais/NotasFiscais4.png';
import NotasFiscais5 from '../imagens/LancNotasFiscais/NotasFiscais5.png';
import NotasFiscais6 from '../imagens/LancNotasFiscais/NotasFiscais6.png';
import NotasFiscais7 from '../imagens/LancNotasFiscais/NotasFiscais7.png';
import NotasFiscais8 from '../imagens/LancNotasFiscais/NotasFiscais8.png';
import NotasFiscais9 from '../imagens/LancNotasFiscais/NotasFiscais9.png';
import NotasFiscais10 from '../imagens/LancNotasFiscais/NotasFiscais10.png';
import NotasFiscais11 from '../imagens/LancNotasFiscais/NotasFiscais11.png';
import NotasFiscais12 from '../imagens/LancNotasFiscais/NotasFiscais12.png';
import NotasFiscais13 from '../imagens/LancNotasFiscais/NotasFiscais13.png';

export default class LancNotasFiscais extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como fazer o lançamento de uma Nota Fiscal"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar emissão de Notas Fiscais:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={NotasFiscais1} alt="Nota Fiscal 1"/>
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={NotasFiscais2} alt="Nota Fiscal 2"/>
                        </div>

                        <h3>Na tela emissão de Notas Fiscais nós temos:</h3>
                        <ol>
                            <li>Emissão de Nota Fiscal de produto.</li>
                            <li>Emissão de Nota Fiscal de serviço.</li>
                            <li>Botão para filtros adicionais para filtrar as Notas Fiscais emitidas.</li>
                            <li>Botão para testar se a comunicação com o SEFAZ está estável.</li>
                            <li>Filtro básico de busca de Nota Fiscal.</li>
                            <li>Tabela com todas as Notas Fiscais transmitidas.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como Emitir uma Nota Fiscal de produtos</h3>
                        <p>
                            Para emitir a nota primeiro clique no botão "Nota de Produto".
                        </p>  
                        <div className="image-wrapper">
                            <img src={NotasFiscais3} alt="Nota Fiscal 3"/>
                        </div>    
                        <p>
                            Depois, na tela aberta preencha as informações corretamente.
                        </p>   
                        <div className="image-wrapper">
                            <img src={NotasFiscais4} alt="Nota Fiscal 4"/>
                        </div>   
                        <p>
                            Na tela principal os dados de valores na parte abaixo são calculados conforme os produtos/serviços são adicionados a nota. 
                        </p>    
                        <div className="image-wrapper">
                            <img src={NotasFiscais6} alt="Nota Fiscal 6"/>
                        </div>                           
                        <p>
                            Nas informações da nota existem 6 abas principais de informações. A primeira aba de "Dados Fiscais" pegas as informações definidas nas configurações
                            do gestor fazendo a emissão da nota. 
                        </p>  
                        <div className="image-wrapper">
                            <img src={NotasFiscais5} alt="Nota Fiscal 5"/>
                        </div>       
                        <p>
                            Na segunda aba de "Produtos da Nota" você pode adicionar os produtos da nota utilizando o botão "+ Novo Produto".
                        </p>     
                        <div className="image-wrapper">
                            <img src={NotasFiscais7} alt="Nota Fiscal 7"/>
                        </div>                                                                        
                        <div className="image-wrapper">
                            <img src={NotasFiscais8} alt="Nota Fiscal 8"/>
                        </div>  
                        <p>
                            Na inclusão de Produtos existe a aba de Impostos. Alguns dos impostos podem ser difinidos como padrão nas configurações do gestor. 
                            Caso for necessário colocar um valor de imposto diferente não se esqueça de preencher corretamente. 
                        </p>
                        <div className="image-wrapper">
                            <img src={NotasFiscais9} alt="Nota Fiscal 9"/>
                        </div>    
                        <p>
                            A terceira aba chamada "Inf. Adicionais" serve para colocar informações adicionais que ficam no campo de informações complementares da nota.
                        </p>   
                        <div className="image-wrapper">
                            <img src={NotasFiscais10} alt="Nota Fiscal 10"/>
                        </div>  
                        <p>
                            A quarta aba serve para definir as informações de transportadora quando existe, e caso não existir, marcar como 9 - Sem frete.
                        </p>   
                        <div className="image-wrapper">
                            <img src={NotasFiscais11} alt="Nota Fiscal 11"/>
                        </div>  
                        <p>
                            A quinta aba serve para adicionar as chaves de outras notas fiscais relacionadas a nota atual que você estiver montando. Um caso que 
                            necessita dessa ligação é quando você estiver emitindo uma nota de devolução, e precise vincular a nota fiscal original.
                        </p>   
                        <div className="image-wrapper">
                            <img src={NotasFiscais12} alt="Nota Fiscal 12"/>
                        </div>   
                        <p>
                            A sexta e última aba define a forma de pagamento da Nota Fiscal, onde você informa o tipo de documento e a Condição de Pagamento.
                        </p>   
                        <div className="image-wrapper">
                            <img src={NotasFiscais13} alt="Nota Fiscal 13"/>
                        </div>                                                                                                           
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancNotasFiscais.js